/* eslint-disable security/detect-object-injection */
import React, {
    useCallback, useMemo, useContext
} from 'react';
import _ from 'lodash';
import { readViewModelValue, appendMetadataWithIndex } from '@xengage/gw-jutro-adapters-react';
import { ViewModelServiceContext, ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import classNames from 'classnames';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { withRouter } from 'react-router-dom';
import { InputField, InputNumberField, DropdownSelectField, } from '@jutro/legacy/components';
import { Link } from '@jutro/router';
import { TranslatorContext } from '@jutro/locale';
import { Icon } from '@jutro/components';
import styles from './MarinaDetailsTableComponent.module.scss';
import metadata from './MarinaDetailsTableComponent.metadata.json5';


function MarinaDetailsTableComponent(props) {

    const {
        updateWizardData,
        submissionVM,
        marinaDetailsTablePath,
        index
    } = props;

    let {
        data: marinaDetailsTableVM,
    } = props;

    const viewModelService = useContext(ViewModelServiceContext);
    const translator = useContext(TranslatorContext);


    const addMarinaDetailsTable = useCallback(
        (event) => {
            if (event) {
                event.preventDefault();
            }

            if(!marinaDetailsTableVM){
                marinaDetailsTableVM = {};
            }
            marinaDetailsTableVM.value = marinaDetailsTableVM.value || []

           const MarinaDetailsTableObjVM = viewModelService.create(
                {},
                "pc",
                "edgegen.capabilities.policyjob.lob.recmarproduct.coverables.dto.marinepleasurecraft.boats.subdto.MarinaDetailsDTO"
            );

            MarinaDetailsTableObjVM.isValidationReq = true;

            marinaDetailsTableVM.pushElement(
                MarinaDetailsTableObjVM
            );
            
            _.set(submissionVM, marinaDetailsTablePath, marinaDetailsTableVM);
            const newSubmissionVM = viewModelService.clone(submissionVM);
            updateWizardData(newSubmissionVM);
        },
        [submissionVM, updateWizardData, marinaDetailsTableVM, viewModelService,]
    );


    const handleValueChange = useCallback(
        () => {
            updateWizardData(submissionVM);
        },
        [submissionVM, updateWizardData]
    );


    const removeMainEngineItem = useCallback(
        (event, index) => {
            if (event) {
                event.preventDefault();
            }

            marinaDetailsTableVM.value.splice(index, 1);
            _.set(submissionVM.value, marinaDetailsTablePath, marinaDetailsTableVM.value);
            updateWizardData(submissionVM);
        }, [submissionVM, updateWizardData, marinaDetailsTablePath, marinaDetailsTableVM?.value]
    );


    const getTableCell = useCallback(
        // eslint-disable-next-line @typescript-eslint/no-shadow
        (item, index, props) => {
            const { path } = props;

            if (path === 'numFie') {
                 let mainEngineArray = _.get(submissionVM, marinaDetailsTablePath);
                mainEngineArray = mainEngineArray.value
                const newNumber = mainEngineArray?.length >= 2 ? mainEngineArray[mainEngineArray.length - 2].numFie + 1 : index + 1;

                if (mainEngineArray[index].numFie === undefined) {
                    mainEngineArray[index].numFie = newNumber;
                    _.set(submissionVM.value, marinaDetailsTablePath, marinaDetailsTableVM.value);
                } 

                const value = index + 1;

                return (
                    <InputField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="number"
                        value={value}
                        readOnly
                    />
                );
            }

            if (path === 'name' || path === 'address' || path === 'city' || path === 'postalCode') {
                const value = item[path] ? item[path] : '';
                const disabled = false;

                return (
                    <InputField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="String"
                        onValueChange={(val, changedPath) => {
                            item[path] = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        disabled={disabled}
                        value={value}
                    />
                );
            }

            if (path === 'itenaryNumber') {
                const value = item[path] ? item[path] : '';

                return (
                    <InputNumberField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        readOnly={true}
                        dataType="number"
                        onValueChange={(val, changedPath) => {
                            item[path] = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        value={value}
                    />
                );
            }  

            if (path === 'province') {
                const value = item[path] ? item[path] : '';
                // eslint-disable-next-line security/detect-object-injection
                const availableValues = marinaDetailsTableVM.length > 0 && marinaDetailsTableVM.children[index].province
                    // eslint-disable-next-line security/detect-object-injection
                    ? marinaDetailsTableVM.children[index].province.aspects.availableValues
                        .map((typeCode) => ({
                            code: typeCode.code,
                            name: translator({
                                id: typeCode.name,
                                defaultMessage: typeCode.name
                            })
                        }))
                    : [];

                return (
                    <DropdownSelectField
                        id={index + path}
                        className={styles.coverageForm}
                        onValueChange={(val, changedPath) => {
                            item[path] = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        dataType="string"
                        path={path}
                        value={value}
                        availableValues={availableValues}
                        searchable
                    />
                );
            } 

        }, [marinaDetailsTablePath, marinaDetailsTableVM?.value, handleValueChange, submissionVM?.value])

    const removeMarinaDetailsTableRow = useCallback(
        (item, index) => (
            // eslint-disable-next-line jsx-a11y/anchor-is-valid
            <Link
                onClick={(e) => removeMainEngineItem(e, index, item)}
                className={classNames(styles.deleteSection, styles.deleteRow)}
            >
                <Icon icon="mi-delete" className={styles.deleteIcon} />
            </Link>
        ),
        [removeMainEngineItem]
    );

    const overrideProps = useMemo(() => ({
        '@field': {
            showOptional: false,
            showRequired: true
        },
        [`marinaDetailsTable${index}`]:{
            data: marinaDetailsTableVM && marinaDetailsTableVM.length > 0 ? marinaDetailsTableVM.value : []
        }

    }), [marinaDetailsTableVM?.value])

    const resolvers = {
        resolveCallbackMap: {
            addMarinaDetailsTable,
            getTableCell,
            removeMarinaDetailsTableRow
        }
    };

    const readValue = useCallback(
        (fieldId, fieldPath) => readViewModelValue(
            metadata.pageContent,
            marinaDetailsTableVM,
            fieldId,
            fieldPath,
            overrideProps
        ),
        [marinaDetailsTableVM, overrideProps]
    );

    const formattedMetadata = useMemo(() => appendMetadataWithIndex(metadata.pageContent, index), [index]);

    return (
        <ViewModelForm
             uiProps={formattedMetadata}
            model={marinaDetailsTableVM}
            overrideProps={overrideProps}
            resolveValue={readValue}
            onValueChange={handleValueChange}
            callbackMap={resolvers.resolveCallbackMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );


}

MarinaDetailsTableComponent.propTypes = wizardProps;
export default withRouter(MarinaDetailsTableComponent);
